import { Input } from './input'

export const Select = {
  ...Input,
  baseStyle: {
    field: {
      backgroundColor: 'white',
    },
  },
  sizes: {
    sm: {
      field: {
        fontSize: '12px',
        padding: '16px',
      },
    },
    md: {
      field: {
        fontSize: '16px',
        paddingTop: '21px',
        paddingBottom: '21px',
        paddingLeft: '16px',
        height: '66px',
      },
    },
  },
  variants: {
    outline: {
      field: {
        backgroundColor: 'white',
        _invalid: {
          boxShadow: 'none',
        },
      },
    },
    solid: {
      bg: 'primary',
      color: 'white',
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'outline',
  },
}
